import React, { useMemo, useState } from "react";
import { Box } from "@mui/material";

import { FirebaseAuth } from "../FirebaseAuth/firebase";
import { useDashboardChrome } from "../DashboardChrome";
import DashboardContent from "./DashboardContent";
import DashboardSidebar from "./DashboardSidebar";
import DashboardTopBar from "./DashboardTopBar";
import { appBarHeight, collapsedDrawerWidth, consoleBorder, expandedDrawerWidth } from "./constants";
import { normalizeItems } from "./utils";

const DashboardShell = ({ title, header, items, activeKey, onSelect, children, compactHeader = false, headerless = false }) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const { accountSwitcher, openSearchPalette, openUserMenu, searchEnabled } = useDashboardChrome();
  const navItems = useMemo(() => normalizeItems(items), [items]);
  const activeItem = navItems.find((item) => item.key === activeKey) || navItems[0] || {};
  const drawerWidth = collapsed ? collapsedDrawerWidth : expandedDrawerWidth;
  const currentUser = FirebaseAuth.auth().currentUser;

  const handleSelect = (key) => {
    onSelect(key);
    setMobileOpen(false);
  };

  return (
    <Box
      sx={{
        display: "flex",
        gap: 0,
        alignItems: "stretch",
        width: "100%",
        textAlign: "left",
        borderTop: `1px solid ${consoleBorder}`,
        bgcolor: "background.paper",
        minHeight: `calc(100vh - ${appBarHeight})`,
      }}
    >
      <DashboardTopBar
        accountSwitcher={accountSwitcher}
        collapsed={collapsed}
        currentUser={currentUser}
        drawerWidth={drawerWidth}
        onOpenMobileNav={() => setMobileOpen(true)}
        onOpenSearch={openSearchPalette}
        onOpenUserMenu={openUserMenu}
        searchEnabled={searchEnabled}
        onToggleCollapsed={() => setCollapsed((value) => !value)}
      />
      <DashboardSidebar
        activeKey={activeItem.key}
        collapsed={collapsed}
        drawerWidth={drawerWidth}
        items={navItems}
        mobileOpen={mobileOpen}
        onCloseMobile={() => setMobileOpen(false)}
        onSelect={handleSelect}
      />
      <DashboardContent activeItem={activeItem} compactHeader={compactHeader} drawerWidth={drawerWidth} header={header} headerless={headerless} title={title}>
        {children}
      </DashboardContent>
    </Box>
  );
};

export default DashboardShell;
